import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SideNavButton } from './SideNavButton';
import { navigateToHelpScreen } from './navigateToHelpScreen';

export const HelpButton = () => {

  return (
    <SideNavButton 
      onClick={navigateToHelpScreen} 
      icon={<FontAwesomeIcon icon={fas.faCircleQuestion} size="2x" />}
    />
  )
}